<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="produtoFilter"
                :items="filterProduto.length > 0 ? filterProduto : produtoOptions"
                label="Filtrar por Produto"
                multiple
                outlined
                dense
                clearable
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-action>
                      <input
                        id="filtroProduto"
                        v-model="filtroProdutos"
                        prepend-inner-icon="mdi-account-search"
                        placeholder="Filtrar Produtos"
                        @change="filterProdutosToggle"
                      >
                    </v-list-item-action>
                    <v-divider class="mt-2" /><br>
                  </v-list-item>
                  <v-list-item
                    slot="prepend-item"
                    ripple
                    @click="toggleProdutos"
                  >
                    <v-list-item-action>
                      <v-icon :color="produtoOptions.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconProdutos }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-title id="idSelecTotos">
                      Selecionar todos
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
            <v-col
              v-if="!enableBtn"
              cols="12"
              md="3"
            >
              <v-btn
                id="btnPrint"
                class="mr-2"
                small
                dark
                :color="corPrimaria"
                :disabled="enableBtn"
                :loading="imprimindo"
                @click="exportPDF()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta PDF
                <template v-slot:loader>
                  <span>Gerando...</span>
                </template>
              </v-btn>
            </v-col>
            <v-col
              v-if="!enableBtn"
              cols="12"
              md="3"
            >
              <v-btn
                id="btnPrint"
                class="mr-2"
                small
                dark
                :color="corPrimaria"
                :disabled="enableBtn"
                :loading="imprimindoExcel"
                @click="exportExcel()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta Excel
                <template v-slot:loader>
                  <span>Gerando...</span>
                </template>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div
                id="idTable"
                style="overflow-x: auto;"
              >
                <table
                  style="width: 100%; color: black; border-collapse: collapse;"
                  class="elevation-1"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      />
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Produto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Faturamento
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Volume
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(item, index) in (filteredItems.length > 0 ? filteredItems : faturamentoVolume)"
                    :key="item.id"
                  >
                    <!-- Linha principal -->
                    <tr>
                      <td style="text-align: center;">
                        <button @click="toggleExpand(index)">
                          {{ expanded.includes(index) ? '▲' : '▼' }}
                        </button>
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ item.produto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ item.faturamento }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ item.volume }}
                      </td>
                    </tr>
                    <!-- Linha expandida -->
                    <tr
                      v-if="expanded.includes(index)"
                      :key="'expanded-' + item.id"
                    >
                      <td colspan="4">
                        <table
                          id="tableExpandida"
                          style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center"
                              >
                                Mês
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                              >
                                Faturamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                              >
                                Volume
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(sub, idx) in item.dadosProdutos"
                              :key="idx"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;"
                              >
                                {{ sub.mes }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ sub.faturamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ sub.volume }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <canvas
            id="analiseFaturamentoVolume"
            width="30"
            height="10"
          />
          <div
            v-if="exibirLegenda"
            id="legendaAnaliseFaturamentoVolume"
            class="text-center px-3"
          >
            <v-row
              align="center"
              class="text-center ma-0"
            >
              <v-avatar
                class="text-center mr-1"
                color="#4780b8"
                size="10"
              />
              <span class="text-center mr-3 font-weight-light">Faturamento</span>
              <v-avatar
                class="text-center mr-1"
                color="#FDD835"
                size="10"
              />
              <span class="text-center mr-3 font-weight-light">Volume</span>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import AnaliseFaturamento from '../../../../../services/analisefaturamento'
  import eventEmit from '../../core/EventoEmit'
  import Chart from 'chart.js'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['dadosMargemTotal'],
    components: {
      DashboardCoreSnackbar: () => import('../../core/Snackbar'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: '#2863af',
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      cidades: [],
      areas: [],
      supervisores: [],
      vendedores: [],
      redes: [],
      headersFaturamentoVolumeTotal: [
        { text: 'Produto', value: 'produto', width: '40%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '30%', align: 'right', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', width: '30%', class: 'black--text title' },
      ],
      headersFaturamentoVolume: [
        { text: 'Mês', value: 'mes', width: '40%', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '30%', align: 'right', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', width: '30%', class: 'black--text title' },
      ],
      faturamentoVolume: [],
      filtroProdutos: '',
      filtroMeses: '',
      filterProduto: [],
      filterMeses: [],
      produtoFilter: [],
      mesFilter: [],
      expanded: [],
      label: [],
      faturamento: [],
      volume: [],
      labelFiltrado: [],
      faturamentoFiltrado: [],
      volumeFiltrado: [],
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableGrafico: false,
      exibirLegenda: false,
      tituloRelatorio: 'Relatório Faturamento Volume',
      arquivo: 'relatorio_faturamento_volume',
      enableBtn: true,
      imprimindo: false,
      imprimindoExcel: false,
    }),

    computed: {
      produtoOptions () {
        return [...new Set(this.faturamentoVolume.map(item => item.produto))]
      },

      filteredItems () {
        return this.faturamentoVolume.filter(item => {
          const produtoMatch = this.produtoFilter.length === 0 || this.produtoFilter.includes(item.produto)

          return produtoMatch
        })
      },

      likesAllProdutos () {
        const baseProduto =
          this.filterProduto.length > 0
            ? this.filterProduto
            : this.produtoOptions

        return this.produtoFilter.length === baseProduto.length
      },

      likesSomeProdutos () {
        return this.produtoFilter.length > 0 && !this.likesAllProdutos
      },

      iconProdutos () {
        if (this.likesAllProdutos) return 'mdi-close-box'
        if (this.likesSomeProdutos) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
    },

    watch: {
      produtoFilter: {
        handler () {
          this.atualizarDadosGrafico()
        },
        deep: true,
      },
    },

    created () {
      eventEmit.$on('update-form-analise-faturamento-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-analise-faturamento-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresa, cidades, areas, supervisores, vendedores, redes) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresa = empresa
        this.cidades = cidades
        this.areas = areas
        this.supervisores = supervisores
        this.vendedores = vendedores
        this.redes = redes

        this.showAnaliseFaturamentoVolume()
      },

      toggleProdutos () {
        this.$nextTick(() => {
          if (this.likesAllProdutos) {
            this.produtoFilter = []
          } else {
            const baseProduto =
              this.filterProduto.length > 0
                ? this.filterProduto
                : this.produtoOptions

            this.produtoFilter = [...baseProduto]
          }
        })
      },

      filterProdutosToggle () {
        this.produtoFilter = []

        if (this.filtroProdutos.length > 0) {
          const baseProduto =
            this.filterProduto.length > 0
              ? this.filterProduto
              : this.produtoOptions

          this.produtoFilter = baseProduto.filter(produto =>
            produto.toLowerCase().includes(this.filtroProdutos.toLowerCase()),
          )
        }
      },

      async showAnaliseFaturamentoVolume () {
        this.loading = true

        this.faturamentoVolume = []

        this.expanded = []

        this.exibirLegenda = false

        this.enableBtn = true

        AnaliseFaturamento.showDadosAnaliseFaturamentoVolume(this.dataInicial, this.dataFinal, this.empresa, this.cidades, this.areas, this.supervisores, this.vendedores, this.redes, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoVolume = resposta.data.dadosExibicao.map((item) => {
              var listaFaturamento = ({
                produto: item.produto,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                volume: item.volume.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                icone: item.icone,
                expandir: item.expandir,
                dadosProdutos: this.getDadosMensais(item.dadosProdutos),
              })

              return listaFaturamento
            })

            this.label = resposta.data.label
            this.faturamento = resposta.data.faturamento
            this.volume = resposta.data.volume

            this.enableGrafico = true

            this.enableBtn = false
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.faturamentoVolume = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loading = false

          this.$nextTick(() => {
            this.montarGrafico()

            this.exibirLegenda = true
          })
        })
      },

      getDadosMensais (value) {
        const dadosProdutos = value.map((item) => {
          var listaFaturamentoVolume = ({
            mes: item.mes,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            faturamentoAux: parseFloat(item.faturamento),
            volumeAux: parseFloat(item.volume),
          })

          return listaFaturamentoVolume
        })

        return dadosProdutos
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      atualizarDadosGrafico () {
        if (this.filteredItems.length > 0) {
          this.faturamentoFiltrado = []
          this.volumeFiltrado = []
          this.labelFiltrado = []

          const agrupados = {}
          const labelsSet = new Set()

          this.filteredItems.forEach((produto) => {
            produto.dadosProdutos.forEach((detalhe) => {
              const data = detalhe.mes

              if (!agrupados[data]) {
                agrupados[data] = {
                  faturamento: 0,
                  volume: 0,
                }
              }

              labelsSet.add(data)

              agrupados[data].faturamento += detalhe.faturamentoAux

              agrupados[data].volume += detalhe.volumeAux
            })
          })

          this.labelFiltrado = Array.from(labelsSet)

          this.faturamentoFiltrado = Object.keys(agrupados).map((data) => agrupados[data].faturamento)

          this.volumeFiltrado = Object.keys(agrupados).map((data) => agrupados[data].volume)

          this.montarGrafico()
        } else {
          this.faturamentoFiltrado = []
          this.volumeFiltrado = []
          this.labelFiltrado = []

          this.montarGrafico()
        }
      },

      montarGrafico () {
        try {
          if (this.myChart?.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('analiseFaturamentoVolume').getContext('2d')

          this.myChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.labelFiltrado.length > 0 ? this.labelFiltrado : this.label,
              datasets: [
                {
                  label: 'Faturamento',
                  data: this.faturamentoFiltrado.length > 0 ? this.faturamentoFiltrado : this.faturamento,
                  borderColor: '#4780b8',
                  backgroundColor: 'transparent',
                  order: 1,
                  fill: false,
                  tension: 0,
                },
                {
                  label: 'Volume',
                  data: this.volumeFiltrado.length > 0 ? this.volumeFiltrado : this.volume,
                  borderColor: '#FDD835',
                  backgroundColor: 'transparent',
                  order: 1,
                  fill: false,
                  tension: 0,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
                xAxes: [{
                  gridLines: {
                    display: false,
                  },
                }],
                yAxes: [{
                  gridLines: {
                    display: false,
                  },
                  display: false,
                }],
              },
              low: 10,
              high: 5,
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    if (tooltipItem.datasetIndex === 0) {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    } else if (tooltipItem.datasetIndex === 1) {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    }
                  },
                },
              },
            },
          })
        } catch (error) {
          console.log(error)
        }
      },

      async exportPDF () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar pdf', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados'
          pdf.text(filtro, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisores.map(v => v.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          if (posYFiltros > 150) {
            pdf.addPage()
            posYFiltros = 10
          }

          posYFiltros += 5

          let previousTableY = posYFiltros

          const dados = this.filteredItems.length > 0 ? this.filteredItems : this.faturamentoVolume

          dados.forEach((row, index) => {
            const dadosTabelaPrincipal = [
              [row.produto, row.faturamento, row.volume],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headersFaturamentoVolumeTotal.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosTabelaPrincipal.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 150 },
                1: { cellWidth: 50 },
                2: { cellWidth: 50 },
              },
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalhesProdutos = row.dadosProdutos.map(item => [item.mes, item.faturamento, item.volume])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersFaturamentoVolume.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosDetalhesProdutos.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 150 },
                1: { cellWidth: 50 },
                2: { cellWidth: 50 },
              },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY + 10
          })

          pdf.save('relatorio_faturamento_volume.pdf')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },

      async exportExcel () {
        try {
          this.imprimindoExcel = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Analise Faturamento Volume')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:F${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nome))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.supervisores.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

            worksheet.addRow([])
            posY += 1
          }

          posY += 1

          inserirTitulo(worksheet)

          const dados = this.filteredItems.length > 0 ? this.filteredItems : this.faturamentoVolume

          dados.forEach(produto => {
            // Adicionar linha do cliente
            posY += 2
            worksheet.addRow(['Produto: ' + produto.produto, 'Faturamento: ' + produto.faturamento, 'Volume: ' + produto.volume]).font = { bold: true }
            posY += 1

            // Adicionar cabeçalhos dos produtos
            const headers = ['Mês', 'Faturamento', 'Volume']
            worksheet.addRow(headers).font = { bold: true }
            posY += 1

            // Adicionar produtos do cliente
            produto.dadosProdutos.forEach(p => {
              worksheet.addRow([p.mes, p.faturamento, p.volume])
              posY += 1
            })

            posY += 3 // Espaçamento entre grupos
            // Adiciona uma linha em branco antes do próximo cliente
            worksheet.addRow([])
            posY += 1
          })

          // Ajustar larguras de coluna automaticamente
          worksheet.columns.forEach(column => {
            let maxLength = 0
            column.eachCell({ includeEmpty: true }, cell => {
              if (cell.value) {
                maxLength = Math.max(maxLength, cell.value.toString().length)
              }
            })
            column.width = maxLength + 2 // +2 para espaçamento
          })

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_faturamento_volume.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindoExcel = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },

  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #textTable {
    font-size: 0.75rem !important
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  .v-data-table__wrapper {
    overflow-x: auto;
  }

  #analiseFaturamentoVolume {
    margin: 8rem 0 0 0
  }

  #legendaAnaliseFaturamentoVolume {
    margin: 2rem 0 0 0rem
  }
</style>
